import { useSuspenseQuery } from "@tanstack/react-query";

import {
  Database,
  useDatabasesNames,
} from "services/databases/useDatabasesNames";
import { ReactQueryKeysAccount } from "services/queryKeys";
import { getPrivilegesByRole } from "services/rbac/getPrivilegesByRole";
import { Role } from "services/rbac/types";

import { useDatabasePrivilegesInEdit } from "components/RolesWizard/useDatabasePrivilegesInEdit";

const getDatabaseLevelPrivileges = async ({
  databases,
  role,
  databasePrivilegesInEditStep,
}: {
  databases: Database[];
  role: Role;
  databasePrivilegesInEditStep: boolean;
}) => {
  if (databasePrivilegesInEditStep) {
    const privileges = [];
    for (const database of databases) {
      // eslint-disable-next-line no-await-in-loop
      const databasePrivileges = await getPrivilegesByRole({
        roleName: role.roleName,
        catalogName: database.catalogName,
      });
      privileges.push(...databasePrivileges);
    }
    return privileges;
  }
  return [];
};

export const useDatabaseLevelPrivileges = (role: Role) => {
  const databases = useDatabasesNames();
  const databasePrivilegesInEditStep = useDatabasePrivilegesInEdit();

  const { data: databaseLevelPrivileges } = useSuspenseQuery({
    queryKey: [ReactQueryKeysAccount.roleDatabasePrivileges, role.roleName],
    queryFn: () =>
      getDatabaseLevelPrivileges({
        role,
        databases,
        databasePrivilegesInEditStep,
      }),
  });

  return databaseLevelPrivileges;
};
